import React from 'react';
import * as css from './siktLogo.module.scss';
import translations from './siktLogo.i18n';
import { useIntl } from 'react-intl';

// TODO Add English version of logo, when available
const SiktLogo = () => {
  const { formatMessage } = useIntl();
  const labels = {
    title: formatMessage({ id: translations.title.id }),
  };

  return (
    <div className={css.footer}>
      <a href={'https://sikt.no/'} target={'_blank'} rel={'noreferrer'}>
        <div title={labels.title} className={css.logo} />
      </a>
    </div>
  );
};

export default SiktLogo;
